import { configureStore } from '@reduxjs/toolkit';
import editorJsonVersionReducer from './EditorJsonVersionSlice';

export const editorJsonVersionStore = configureStore({
    reducer: {
        editorJsonVersion: editorJsonVersionReducer
    },
});

export default editorJsonVersionStore;